const report = {
    id: `report-${Math.random()}`,
    title: 'Report',
    type: 'item',
    url: `/settlement/report`,
    // icon: icons.IconReport,
    breadcrumbs: false,
    // children: transChild,
    role: process.env.REACT_APP_RL_SETTLEMENTCH
};

export default report;
